import { render, staticRenderFns } from "./AddLoyaltyProgram.vue?vue&type=template&id=1061fe72&"
import script from "./AddLoyaltyProgram.vue?vue&type=script&lang=js&"
export * from "./AddLoyaltyProgram.vue?vue&type=script&lang=js&"
import style0 from "./AddLoyaltyProgram.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports